import React from 'react';

import { Typography } from '@mui/material';

interface Props {
  value: string;
}

function RoomPolicyFormTextWidget({ value }: Props) {
  return <Typography variant="h5">{value}</Typography>;
}

export default RoomPolicyFormTextWidget;
